export { AtnDsSelectSingleEcComponent as Component } from './single-ec.component'
export * as ec from './ec-plugin'
